import { render } from "./Campaign20230410_2.vue?vue&type=template&id=40210318&scoped=true"
import script from "./Campaign20230410_2.vue?vue&type=script&lang=js"
export * from "./Campaign20230410_2.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-40210318"

export default script